import { Card } from '../ui/card';
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "../ui/carousel";
import { Quote } from "lucide-react";
import { ImageWithFallback } from './ImageWithFallback';
import narasimhamurthy from '../../assets/img/testimonials/narasimhamurthy.jpeg';
import dundiraj from '../../assets/img/testimonials/dundiraj.jpeg';

type Testimonial = {
    name: string;
    designation: string;
    message: string;
    image: string;
};

const testimonials: Testimonial[] = [
    {
        name: "ಎಂ ಎಸ್ ನರಸಿಂಹಮೂರ್ತಿ",
        designation: "",
        message:
            "ಚಿಂತಾಮಣಿ ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾದಲ್ಲಿ ನಾನು ಹಲವು ಉತ್ತಮ ಅಂಶಗಳನ್ನು ಕಂಡೆ. ಸಕ್ರಿಯ ಸದಸ್ಯರೆಲ್ಲರೂ ಒಂದಲ್ಲ ಒಂದು ರಂಗದಲ್ಲಿ ಪ್ರಖ್ಯಾತರು. ಬ್ರಾಹ್ಮಣ ಸಂಘ ಏರ್ಪಡಿಸಿದ್ದ ರಾಜ್ಯೋತ್ಸವ ಕಾರ್ಯಕ್ರಮದಲ್ಲಿ ಎಲ್ಲರೂ ಒಗ್ಗಟ್ಟಾಗಿ ಇದು ತಮ್ಮ ಮನೆಯಲ್ಲಿ ನಡೆಯುವ ಸತ್ಯನಾರಾಯಣ ಪೂಜೆ ಎಂಬಂತೆ ಪಾಲ್ಗೊಂಡಿದ್ದರು. ಸಂಘ ಎಂದ ಮೇಲೆ ಭಿನ್ನಾಭಿಪ್ರಾಯಗಳು ಸಹಜ.  ಇವು ಸಕಾರಾತ್ಮಕವಾಗಿ ಇದ್ದಾಗ ಸಂಘಕ್ಕೆ ಲಾಭ. ನಾವೆಲ್ಲರೂ ಒಂದು ಎಂಬ ಗುರಿಯೊಂದಿಗೆ  ಮುನ್ನಡೆಯಬೇಕು. ಈ ಸಲ ನಡೆದ ರಾಜ್ಯೋತ್ಸವ ಕಾರ್ಯಕ್ರಮ ಅದ್ಭುತವಾಗಿತ್ತು. ಬಂದಿದ್ದ ಅತಿಥಿಗಳಿಗೆ ತುಂಬಾ ಸಂತೋಷವಾಯಿತು. ಇರುವ ಬ್ಯಾಂಕ್ ಬ್ಯಾಲೆನ್ಸ್ ಅನ್ನು ಕರಗಿಸದೆ ಕಾರ್ಯಕ್ರಮಗಳು ನಡೆಸುವುದು ಜಾಣತನ. ಆಗುವ ಖರ್ಚುಗಳನ್ನು ನಾವು ಹಂಚಿಕೊಳ್ಳುತ್ತಾ ಸ್ವಲ್ಪ ಆದರೂ ಹಣ ಉಳಿಸಿ ಮೂಲ ಇಡುಗಂಟಿಗೆ ಸೇರಿಸುತ್ತಾ ಹೋದರೆ ಚೆನ್ನ. ಆಯ್ಕೆಯಾದ ಪದಾಧಿಕಾರಿಗಳಿಗೆ ಎಲ್ಲ ಸದಸ್ಯರ ಬೆಂಬಲ ಸಿಗಬೇಕು. ಆಗ ಎಲ್ಲವೂ ಸುಸೂತ್ರವಾಗಿ  ನಡಿಯುತ್ತವೆ. ಸಾಮೂಹಿಕ ಉಪನಯನಗಳು ನಡೆದಾಗ ವಟುಗಳಿಗೆ ಹದಿನಾರು ದಿನಗಳ ಕಾಲ ದಿನಕ್ಕೆ ಒಮ್ಮೆಯಾದರೂ ಸಂಧ್ಯಾವಂದನೆ ಮಾಡುವುದನ್ನು ನಮ್ಮ ಸಂಘದ ಒಂದಿಬ್ಬರು ಸದಸ್ಯರು ಹೋಗಿ ಹೇಳಿ ಕೊಡಬೇಕು. ಇಲ್ಲವಾದರೆ ಈ ಕಾಲದ ವಟುಗಳು ಮಂತ್ರ ಮರೆತೇ ಬಿಡುತ್ತಾರೆ ಕೋಲಾರ ಜಿಲ್ಲೆಯಲ್ಲಿ ಮೊದಲ ಬಾರಿಗೆ ಇಷ್ಟು ಉತ್ತಮವಾದ  ಸಂಘದ ಕಾರ್ಯ ಚಟುವಟಿಕೆಗಳನ್ನು ನಾನು ಕಂಡೆ. ವೆಬ್ ಸೈಟ್ ಸಹ ಶುರುವಾಗಿದೆ. ಸಂತೋಷವಾಯಿತು. ಈ ಹುಮ್ಮಸ್ಸು ಹೀಗೆ ಮುಂದುವರೆಯಲಿ ಸಮುದಾಯಕ್ಕಾಗಿ ನಮ್ಮೆಲ್ಲರ ಬೆಂಬಲ ಇರಲಿ ಎಂದು ಆಶಿಸುತ್ತೇನೆ",
        image: narasimhamurthy,
    },
    {
        name: "ಡುಂಡಿರಾಜ್ ",
        designation: "ಶಿಕ್ಷಕಿ",
        message:
            "ಚಿಂತಾಮಣಿ ತಾಲೂಕು ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾ ಏರ್ಪಡಿಸಿದ್ದ ರಾಜ್ಯೋತ್ಸವ ಕಾರ್ಯಕ್ರಮದಲ್ಲಿ ಪಾಲ್ಗೊಂಡು ತುಂಬಾ ಸಂತೋಷವಾಯಿತು. ನಮ್ಮ ನಗೆ ಮಾತು ಕವಿತೆಗಳಿಗೆ ಕೇಳುಗರ ಸ್ಪಂದನ ಅತ್ಯುತ್ತಮವಾಗಿತ್ತು. ನೀವು ತೋರಿದ ಪ್ರೀತಿ ನೀಡಿದ ಆತಿಥ್ಯ ಅನನ್ಯ. ಬಿಸಿಬೇಳೆ ಭಾತ್ ನೆನೆದರೆ ಈಗಲೂ ನಾಲಿಗೆ ನೀರೂರುತ್ತದೆ. ಇನ್ನೂ ಕೆಲವು ದಿನ ನೀವು ಕೊಟ್ಟ ಶೇಂಗಾ ಮೆಲ್ಲುತ್ತ ಕಾರ್ಯಕ್ರಮದ ಸವಿ ನೆನಪುಗಳನ್ನು ಮೆಲುಕು ಹಾಕುತ್ತೇನೆ. ಶ್ರೀ ಕೃಷ್ಣ ಹಾಗೂ ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭಾದ ಎಲ್ಲ ಪದಾಧಿಕಾರಿಗಳಿಗೆ ಧನ್ಯವಾದಗಳು. 🙏",
        image: dundiraj,
    },
];

const TestimonialsComponent = () => {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4">
                {/* Heading */}
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-bold text-[#4A0404] mb-3">
                        ಅಭಿಪ್ರಾಯಗಳು
                    </h2>
                    <p className="text-gray-600">
                        ಚಿಂತಾಮಣಿ ಬ್ರಾಹ್ಮಣ ಮಹಾಸಭೆಯ ಕಾರ್ಯಕ್ರಮದ ಕುರಿತು ಮುಖ್ಯ ಅತಿಥಿಗಳು ವ್ಯಕ್ತಪಡಿಸಿದ ಅಭಿಪ್ರಾಯಗಳು ಮತ್ತು ಸಂದೇಶಗಳು.
                    </p>
                    <div className="mt-4 h-1 w-28 mx-auto bg-gradient-to-r from-[#4A0404] to-[#F59E0B] rounded" />
                </div>

                {/* Slider */}
                <div className="relative overflow-visible">
                    <Carousel className="relative ">
                        <CarouselContent>
                            {testimonials.map((item, index) => (
                                <CarouselItem key={index}>
                                    <Card className="p-10 shadow-lg border border-gray-100">
                                        <div className="flex flex-col md:flex-row items-center gap-8 testimonial-container">

                                            {/* Image */}
                                            <div className="flex-shrink-0">
                                                <div className="h-28 w-28 rounded-full border-4 border-[#F59E0B] overflow-hidden testimonial-image">
                                                    <ImageWithFallback
                                                        src={item.image}
                                                        alt={item.name}
                                                        className="h-full w-full object-cover"
                                                    />
                                                </div>
                                            </div>

                                            {/* Content */}
                                            <div className="text-center md:text-left">
                                                <Quote className="h-8 w-8 text-[#F59E0B] mb-4 mx-auto md:mx-0" />

                                                <p className="text-lg text-gray-700 italic mb-4">
                                                    “{item.message}”
                                                </p>

                                                <h4 className="text-xl font-semibold text-[#4A0404]">
                                                    {item.name}
                                                </h4>
                                                {/* <span className="text-sm text-gray-500">
                                                    {item.designation}
                                                </span> */}
                                            </div>
                                        </div>
                                    </Card>
                                </CarouselItem>
                            ))}
                        </CarouselContent>

                        {/* Controls */}
                        <CarouselPrevious className="absolute left-4 top-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-gradient-to-br from-[#800000] to-[#F59E0B] text-white border-none shadow-lg z-20 bg-gradient-to-br from-[#800000] to-[#F59E0B]" />
                        <CarouselNext className="absolute right-4 top-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-gradient-to-br from-[#800000] to-[#F59E0B] text-white border-none shadow-lg z-20 bg-gradient-to-br from-[#800000] to-[#F59E0B]" />
                    </Carousel>
                </div>
            </div>
        </section>
    );
};

export default TestimonialsComponent;
